"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordField = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("./TextField.styled"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["automationId", "className", "disabled", "defaultValue", "errorMessage", "id", "name", "textFieldStyle", "label", "IS_PASSWORD"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextField = _react["default"].forwardRef(function (_ref, ref) {
  var automationId = _ref.automationId,
      className = _ref.className,
      disabled = _ref.disabled,
      defaultValue = _ref.defaultValue,
      errorMessage = _ref.errorMessage,
      id = _ref.id,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? null : _ref$name,
      _ref$textFieldStyle = _ref.textFieldStyle,
      textFieldStyle = _ref$textFieldStyle === void 0 ? 'primary' : _ref$textFieldStyle,
      label = _ref.label,
      _ref$IS_PASSWORD = _ref.IS_PASSWORD,
      IS_PASSWORD = _ref$IS_PASSWORD === void 0 ? false : _ref$IS_PASSWORD,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = [className];
  (0, _react.useEffect)(function () {
    if (!automationId) {
      console.warn("Automation id was not provided.");
    }
  }, []);

  if (textFieldStyle === "primary-background") {
    classes.push("has-background");
    textFieldStyle = 'primary';
  }

  if (textFieldStyle === 'outlined') {
    classes.push("outlined");
    textFieldStyle = 'primary';
  }

  if (textFieldStyle === "primary") {
    classes.push("animated");
  }

  if (textFieldStyle === 'compact') {
    classes.push('compact');
  }

  if (errorMessage) {
    classes.push("error");
  }

  if (disabled) {
    classes.push('disabled');
  }

  if (defaultValue || props.value && disabled) {
    classes.push('valid');
  }

  return _react["default"].createElement(_TextField["default"], {
    className: classes.join(" ")
  }, _react["default"].createElement("input", _extends({}, props, {
    className: disabled && (defaultValue || props.value) ? 'valid' : '',
    required: textFieldStyle === 'primary',
    defaultValue: defaultValue,
    type: IS_PASSWORD === true ? 'password' : 'text',
    id: id,
    name: name || id,
    disabled: disabled,
    placeholder: textFieldStyle.toLowerCase().trim() === 'compact' ? label : null,
    key: id || "",
    ref: ref
  })), textFieldStyle === 'primary' ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("label", {
    htmlFor: id
  }, " ", label), _react["default"].createElement("span", {
    className: "focus-bar"
  })) : _react["default"].createElement("label", {
    style: {
      display: 'none'
    },
    htmlFor: id
  }, label), errorMessage ? _react["default"].createElement("p", {
    className: "error-message"
  }, errorMessage) : null);
});

TextField.defaultProps = {
  automationId: '',
  className: '',
  disabled: false,
  defaultValue: '',
  errorMessage: '',
  id: '',
  textFieldStyle: 'primary',
  label: ''
};
TextField.props = {
  automationId: '',
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  id: _propTypes["default"].string,
  textFieldStyle: _propTypes["default"].oneOf(['', 'primary', 'primary-background', 'outlined', 'compact']),
  label: ''
};
var _default = TextField;
exports["default"] = _default;

var PasswordField = _react["default"].forwardRef(function (_ref2, ref) {
  var props = _extends({}, _ref2);

  return _react["default"].createElement(TextField, _extends({
    ref: ref
  }, props, {
    IS_PASSWORD: true
  }));
});

exports.PasswordField = PasswordField;
PasswordField.defaultProps = {
  automationId: '',
  className: '',
  disabled: false,
  defaultValue: '',
  errorMessage: '',
  id: '',
  textFieldStyle: 'primary',
  label: ''
};
PasswordField.props = {
  automationId: '',
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  textFieldStyle: _propTypes["default"].oneOf(['', 'primary', 'primary-background', 'outlined', 'compact']),
  label: ''
};